var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11 3c.55 0 1 .45 1 1s-.45 1-1 1h0-6v14h6c.55 0 1 .45 1 1s-.45 1-1 1h0-6c-1.1 0-2-.9-2-2h0V5c0-1.1.9-2 2-2h0zm6 6.21c0-.45.54-.67.86-.35h0l2.79 2.79c.19.19.19.51-.01.7h0l-2.79 2.79c-.31.32-.85.1-.85-.35h0V13h-7c-.55 0-1-.45-1-1h0l.007-.116c.058-.496.482-.884.993-.884h7z",
    transform: "translate(-1132 -123) translate(1116 54.351) translate(16 68.649)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsLogout);
export default __webpack_public_path__ + "static/media/icons-logout.b66a3d21a913048f32efd7898122ca52.svg";
export { ForwardRef as ReactComponent };